import { render, staticRenderFns } from "./step-progress-bar.vue?vue&type=template&id=5b0ce2c4"
import script from "./step-progress-bar.vue?vue&type=script&lang=js"
export * from "./step-progress-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports